// src/page_index.ts
import { initializeSharedComponents } from './shared-init';
import { apiCall } from './api';

// Initialize shared components (header, announcements, etc.)
initializeSharedComponents('index');

const els = {
  counter: document.getElementById('counter') as HTMLSpanElement,
};

async function loadCounter() {
  try {
    const data = await apiCall<{ num_hits: number }>('GET', '/api/counter', {
      params: { a: 'Hit counter' },
    });
    els.counter.textContent = String(data.num_hits);
  } catch (e: unknown) {
    els.counter.textContent = 'error';
  }
}

// Load page-specific content
await loadCounter();


